import { createSlice } from '@reduxjs/toolkit';
import {
  createBudgetExpense,
  fetchAllBudgetExpenses,
  fetchBudgetExpenseById,
  updateBudgetExpense,
  deleteBudgetExpense
} from './budgetExpensesActions';
import { BudgetExpensesState } from './budgetExpensesTypes';

const initialState: BudgetExpensesState = {
  expenses: [],
  selectedExpense: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const budgetExpensesSlice = createSlice({
  name: 'budgetExpenses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createBudgetExpense.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createBudgetExpense.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        // state.expenses.push(action.payload.data);
      })
      .addCase(createBudgetExpense.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllBudgetExpenses.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllBudgetExpenses.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.expenses = action.payload.data;
      })
      .addCase(fetchAllBudgetExpenses.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchBudgetExpenseById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchBudgetExpenseById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedExpense = action.payload.data;
      })
      .addCase(fetchBudgetExpenseById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateBudgetExpense.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateBudgetExpense.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        // const index = state.expenses.findIndex(e => e.budget_expense_id === action.payload.id);
        // if (index !== -1) {
        //   state.expenses[index] = { ...action.payload.data, budget_expense_id: action.payload.id };
        // }
      })
      .addCase(updateBudgetExpense.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deleteBudgetExpense.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteBudgetExpense.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.expenses = state.expenses.filter(e => e.budget_expense_id !== action.payload);
      })
      .addCase(deleteBudgetExpense.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default budgetExpensesSlice.reducer;
